module.exports = __webpack_public_path__ + "assets/expert-consult.7447dd6a.svg";